import { DateTime } from 'luxon'

import { parseDateAsDateTime } from './dates'

export const TOTAL_KEY = 'Total'
export const USED_KEY = 'Used'

export const mergePressureSeries = (total, used) => {
  const events = [
    ...total.map((e) => ({ timestamp: parseDateAsDateTime(e.date).toMillis(), key: TOTAL_KEY, value: e.counter })),
    ...used.map((e) => ({
      timestamp: parseDateAsDateTime(e.date).toMillis(),
      key: USED_KEY,
      value: e.booking_counter,
    })),
  ].sort((a, b) => a.timestamp - b.timestamp)

  const points = []
  const current = { [TOTAL_KEY]: null, [USED_KEY]: null }
  events.forEach(({ timestamp, key, value }) => {
    current[key] = value
    const lastPoint = points[points.length - 1]
    if (lastPoint?.timestamp === timestamp) {
      lastPoint[key] = value
    } else {
      points.push({ timestamp, ...current })
    }
  })

  return points.flatMap((point, index) => {
    const next = points[index + 1]
    const dailyPoints = [point]
    if (next) {
      let day = DateTime.fromMillis(point.timestamp).startOf('day').plus({ days: 1 })
      while (day.toMillis() < next.timestamp) {
        dailyPoints.push({ ...point, timestamp: day.toMillis() })
        day = day.plus({ days: 1 })
      }
    }
    return dailyPoints
  })
}

export const getDefaultBrushIndexes = (points, now) => {
  const earliestDate = DateTime.fromMillis(points[0].timestamp)
  const latestDate = DateTime.fromMillis(points[points.length - 1].timestamp)
  let windowStart = DateTime.fromMillis(now).minus({ months: 1 })
  let windowEnd = DateTime.fromMillis(now).plus({ months: 1 })
  if (latestDate <= windowStart) {
    windowStart = latestDate.minus({ months: 2 })
    windowEnd = latestDate
  } else if (earliestDate >= windowEnd) {
    windowStart = earliestDate
    windowEnd = earliestDate.plus({ months: 2 })
  }

  const startIndex = points.findIndex((p) => p.timestamp >= windowStart.toMillis())
  const endIndex = points.findLastIndex((p) => p.timestamp <= windowEnd.toMillis())
  return { startIndex, endIndex }
}
